import { z } from "zod";
import {
    BillColumn,
    BillLineItemColumn,
    BillsByVendorColumn,
} from "../../../types/views/billViews";

export const billExportColumnSchema = z.union([
    z.nativeEnum(BillColumn),
    z.nativeEnum(BillLineItemColumn),
    z.nativeEnum(BillsByVendorColumn),
    z.string().startsWith("ledgerAccount:"),
    z.string().startsWith("ledgerPayable:"),
]);

export type BillExportColumn = z.infer<typeof billExportColumnSchema>;
